<template>
  <v-card @click="cambiarProveedor" flat max-height="500" class="minimal-card">
    <v-img
      src="@/assets/man-woman.jpg"
      height="100"
      class="d-flex align-end"
      gradient="to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7)"
      cover
    >
      <v-card-title class="white--text text-subtitle-1 text-center w-100 pa-0">
        {{ isProveedor ? proveedor.nombre : "Aquí aparece el proveedor" }}
      </v-card-title>
    </v-img>

    <v-card-text v-if="isProveedor" class="py-1 px-2">
      <div class="info-group" v-if="proveedor.categorias && proveedor.categorias.length > 0">
        <strong>Categorías:</strong>
        <span>{{ proveedor.categorias.map(c => c.name).join(", ") }}</span>
      </div>

      <div class="info-group">
        <strong>Dirección:</strong>
        <span>{{ proveedor.direccion }}, {{ proveedor.localidad.nombre }} - {{ proveedor.localidad.provincia.nombre }}</span>
      </div>

      <div class="info-group">
        <strong>Teléfono:</strong>
        <span>{{ proveedor.telefono }}</span>
      </div>

      <div class="info-group">
        <strong>Email:</strong>
        <span>{{ proveedor.email }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "proveedor.info",
  props: {
    proveedor: {
      type: Object,
      required: true,
      default: () => null,
    },
  },
  computed: {
    isProveedor() {
      return !!this.proveedor;
    },
  },
  methods: {
    cambiarProveedor() {
      this.$emit("change-proveedor");
    },
  },
};
</script>

<style scoped>
.minimal-card {
  cursor: pointer;
}

.info-group {
  margin-bottom: 6px;
  font-size: 0.85rem;
  color: #ddd;
}

.info-group strong {
  display: block;
  margin-bottom: 2px;
  color: #fff;
}
</style>
